import { Box, SxProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  label?: ReactNode;
  sx?: SxProps;
};

const renderLabel = (label: ReactNode) => {
  if (typeof label === 'string' || typeof label === 'number') {
    return <Typography sx={{ marginRight: 1 }}>{label}</Typography>;
  }

  return label;
};

function Label({ children, label, sx }: Props) {
  return (
    // pls fix me
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {label ? (
        <Box component='label' sx={{ display: 'flex', alignItems: 'center', ...sx }}>
          {renderLabel(label)}
          {children}
        </Box>
      ) : (
        children
      )}
    </>
  );
}



export default Label;
